<header cdx-header>
  <cdx-header-global>
    <div class="user-name">
      {{ userDisplayName }}
    </div>
  </cdx-header-global>
</header>
